import { Spin } from "antd";
import { useEffect, useState } from "react";
import { refreshAccessToken } from "./app/api/client";
import { runRefresh } from "./app/api/refresh-lock";
import { Providers } from "./app/providers";
import { AppRouter } from "./app/router";
import { useAuthStore } from "./modules/auth/store/auth.store";

/**
 * Ilova ochilganda bitta jimgina refresh urinishi qiladi.
 *
 * Access token faqat xotirada, refresh token esa httpOnly cookie'da va JS uchun
 * ko'rinmaydi — shuning uchun sessiya bor-yo'qligini bilishning yagona yo'li
 * so'rov yuborish. Mehmon foydalanuvchi uchun qaytadigan 401 kutilgan holat,
 * xato emas.
 */
function AuthInitializer({ children }: { children: React.ReactNode }) {
	const setLoading = useAuthStore((state) => state.setLoading);
	const [isBooting, setIsBooting] = useState(true);

	useEffect(() => {
		let cancelled = false;

		runRefresh(refreshAccessToken)
			.catch(() => {
				// Sessiya yo'q — normal holat, hech narsa qilinmaydi.
			})
			.finally(() => {
				if (!cancelled) {
					setLoading(false);
					setIsBooting(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [setLoading]);

	if (isBooting) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<Spin size="large" />
			</div>
		);
	}

	return <>{children}</>;
}

function App() {
	return (
		<Providers>
			<AuthInitializer>
				<AppRouter />
			</AuthInitializer>
		</Providers>
	);
}

export default App;
